<template>
  <div class="mall-h5">
    <!-- 顶部导航 -->
    <div class="mh5-topbar">
      <van-icon name="arrow-left" @click="$router.back()" />
      <span>确认订单</span>
    </div>

    <!-- 配送方式(含收货信息,按tab切换) -->
    <div class="mh5-section">
      <div class="mh5-section__head">
        <van-icon name="logistics-o" />
        <span>配送方式</span>
      </div>
      <div class="mh5-seg">
        <div :class="['mh5-seg__item', { 'is-active': form.deliveryType === 'express' }]" @click="form.deliveryType = 'express'">
          <van-icon name="logistics-o" />
          <span>快递配送</span>
        </div>
        <div :class="['mh5-seg__item', { 'is-active': form.deliveryType === 'pickup' }]" @click="form.deliveryType = 'pickup'">
          <van-icon name="shop-o" />
          <span>线下自提</span>
        </div>
      </div>
      <!-- 快递配送:收货信息表单 -->
      <div class="mh5-form" v-if="form.deliveryType === 'express'">
        <div class="mh5-form__row">
          <label>收货人</label>
          <input v-model="form.receiverName" placeholder="请输入收货人姓名" />
        </div>
        <div class="mh5-form__row">
          <label>手机号</label>
          <input v-model="form.receiverPhone" maxlength="11" placeholder="请输入11位手机号" type="tel" />
        </div>
        <div class="mh5-form__row mh5-form__row--region">
          <label>所在地区</label>
          <van-field v-model="regionText" placeholder="请选择省/市/区" readonly is-link @click="showArea=true" />
          <van-popup v-model="showArea" position="bottom"><van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showArea=false" /></van-popup>
        </div>
        <div class="mh5-form__row">
          <label>详细地址</label>
          <textarea v-model="form.receiverAddress" rows="2" placeholder="街道、门牌号等详细信息" />
        </div>
      </div>
      <!-- 线下自提:无需收货信息 -->
      <div class="mh5-pickup-tip" v-else>
        <van-icon name="shop-o" class="mh5-pickup-tip__icon" />
        <div class="mh5-pickup-tip__text">线下自提 · 无需填写收货地址，请到店自提</div>
      </div>
    </div>

    <!-- 商品清单 -->
    <div class="mh5-section">
      <div class="mh5-section__head">
        <van-icon name="goods" />
        <span>商品清单</span>
        <span class="mh5-section__count">共 {{ totalCount }} 件</span>
      </div>
      <div class="mh5-goods-list">
        <div class="mh5-goods" v-for="item in items" :key="item.productId">
          <div class="mh5-goods__img">
            <img v-if="item.mainImg" :src="item.mainImg" />
            <div v-else class="mh5-noimg">无图</div>
          </div>
          <div class="mh5-goods__body">
            <div class="mh5-goods__name">{{ item.productName }}</div>
            <div class="mh5-goods__spec" v-if="item.spec">{{ item.spec }}</div>
            <div class="mh5-goods__bottom">
              <span class="mh5-price">¥{{ item.price }}</span>
              <span class="mh5-goods__qty">×{{ item.quantity }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 备注 -->
    <div class="mh5-section">
      <div class="mh5-form__row mh5-form__row--remark">
        <label>订单备注</label>
        <input v-model="form.remark" placeholder="选填，如有特殊要求请备注" />
      </div>
    </div>

    <!-- 付款方式 -->
    <div class="mh5-section">
      <div class="mh5-section__head">
        <van-icon name="gold-coin-o" />
        <span>付款方式</span>
      </div>
      <div class="mh5-pay">
        <div :class="['mh5-pay__item', { 'is-active': form.payType === 1 }]" @click="form.payType = 1">
          <div class="mh5-pay__left">
            <van-icon name="wechat-pay" class="mh5-pay__icon mh5-pay__icon--wx" />
            <span class="mh5-pay__name">微信付款</span>
          </div>
          <van-icon :name="form.payType === 1 ? 'success' : 'circle'" class="mh5-pay__check" />
        </div>
        <div :class="['mh5-pay__item', { 'is-active': form.payType === 2 }]" @click="form.payType = 2">
          <div class="mh5-pay__left">
            <van-icon name="balance-o" class="mh5-pay__icon mh5-pay__icon--offline" />
            <span class="mh5-pay__name">线下付款</span>
          </div>
          <van-icon :name="form.payType === 2 ? 'success' : 'circle'" class="mh5-pay__check" />
        </div>
      </div>
      <template v-if="form.payType === 2">
        <div class="mh5-pay__amount">
          <label>实付金额</label>
          <div class="mh5-pay__amount-input">
            <span class="mh5-pay__amount-symbol">¥</span>
            <input v-model="form.offlinePayPrice" type="number" inputmode="decimal" placeholder="请输入线下实付金额" />
          </div>
        </div>
        <div class="mh5-pay__tip">
          <van-icon name="info-o" /> 提交后订单为「待确认」状态，请线下完成付款并联系管理员确认到账后转为已支付。
        </div>
      </template>
    </div>

    <!-- 底部安全区 -->
    <div class="mh5-safe-bottom" />

    <!-- 底部提交栏 -->
    <div class="mh5-submit">
      <div class="mh5-submit__total">
        <span class="mh5-submit__label">合计</span>
        <span class="mh5-submit__price">¥{{ payAmount }}</span>
        <span class="mh5-submit__origin" v-if="showOriginDiff">¥{{ total }}</span>
      </div>
      <div class="mh5-submit__btn" :class="{ disabled: submitting }" @click="onSubmit">
        {{ submitting ? '提交中...' : '提交订单' }}
      </div>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data'
import { mallH5CreateOrder } from '@/api/mall'
import { clearCart } from './cartStore'
import { ensureWxCode, clearWxCode } from './wxAuth'
import { restoreMallCtx, withCtx, getProductId, getSaleOrgId } from './mallCtx'

// 线下自提标识,与后端 express_company 约定一致
const SELF_PICKUP = '线下自提'

export default {
  name: 'MallH5Checkout',
  data() {
    return {
      items: [],
      form: { receiverName: '', receiverPhone: '', receiverProvince: '', receiverCity: '', receiverDistrict: '', receiverAddress: '', remark: '', payType: 1, offlinePayPrice: '', deliveryType: 'express' },
      areaList,
      showArea: false,
      regionText: '',
      submitting: false,
      mode: 'cart'
    }
  },
  computed: {
    total() {
      return this.items.reduce((s, i) => s + Number(i.price) * i.quantity, 0).toFixed(2)
    },
    totalCount() {
      return this.items.reduce((s, i) => s + i.quantity, 0)
    },
    // 线下付款时底部合计显示实付金额,否则显示商品总价
    payAmount() {
      if (this.form.payType === 2) {
        const p = Number(this.form.offlinePayPrice)
        if (this.form.offlinePayPrice !== '' && !isNaN(p)) return p.toFixed(2)
      }
      return this.total
    },
    // 线下付款且实付金额与商品总价不同时,展示原价删除线(议价/抹零场景)
    showOriginDiff() {
      if (this.form.payType !== 2) return false
      const p = Number(this.form.offlinePayPrice)
      if (this.form.offlinePayPrice === '' || isNaN(p)) return false
      return Math.abs(p - Number(this.total)) > 0.001
    }
  },
  created() {
    restoreMallCtx(this.$route)
    const raw = sessionStorage.getItem('mall_buy_now')
    this.items = raw ? JSON.parse(raw) : []
    this.mode = this.$route.query.mode || 'cart'
    if (this.items.length === 0) {
      this.$toast('没有可结算的商品')
      this.$router.replace({ path: '/h5/mall/list', query: withCtx() })
    }
  },
  methods: {
    validate() {
      // 线下自提无需收货信息;普通快递需校验收货人/手机号/地区/详细地址
      if (this.form.deliveryType === 'express') {
        if (!this.form.receiverName.trim()) { this.$toast('请填写收货人姓名'); return false }
        if (!/^1\d{10}$/.test(this.form.receiverPhone)) { this.$toast('手机号格式不正确'); return false }
        if (!this.regionText) { this.$toast('请选择所在地区'); return false }
        if (!this.form.receiverAddress.trim()) { this.$toast('请填写详细地址'); return false }
      }
      if (this.form.payType === 2) {
        const p = Number(this.form.offlinePayPrice)
        if (this.form.offlinePayPrice === '' || isNaN(p) || p < 0.01) {
          this.$toast('请输入线下实付金额(不少于0.01元)')
          return false
        }
      }
      return true
    },
    onAreaConfirm(values) {
      if (!values || values.length < 3) return
      this.form.receiverProvince = values[0].name
      this.form.receiverCity = values[1].name
      this.form.receiverDistrict = values[2].name
      this.regionText = [values[0].name, values[1].name, values[2].name].join('')
      this.showArea = false
    },
    async onSubmit() {
      if (this.submitting) return
      if (!this.validate()) return
      const saleOrgId = getSaleOrgId()
      if (!saleOrgId) {
        this.$toast('缺少销售机构信息，请重新进入商城')
        return
      }
      const isOffline = this.form.payType === 2
      const isPickup = this.form.deliveryType === 'pickup'
      this.submitting = true
      try {
        const pid = getProductId()
        let wxCode = null
        if (!isOffline) {
          // 微信支付需要网页授权code;线下付款跳过
          // ensureWxCode: 有缓存code直接返回;无则跳转微信授权(返回null,需用户授权后重新提交)
          wxCode = await ensureWxCode()
          if (!wxCode) {
            // 已跳转微信授权页,本次提交中止
            return
          }
        }
        const data = {
          items: this.items.map(i => ({ productId: i.productId, quantity: i.quantity })),
          productId: pid ? Number(pid) : null,
          saleOrgId: Number(saleOrgId),
          remark: this.form.remark,
          payType: this.form.payType
        }
        // 普通快递传收货信息;线下自提传自提标识,无需收货信息
        if (!isPickup) {
          data.receiverName = this.form.receiverName
          data.receiverPhone = this.form.receiverPhone
          data.receiverProvince = this.form.receiverProvince
          data.receiverCity = this.form.receiverCity
          data.receiverDistrict = this.form.receiverDistrict
          data.receiverAddress = this.form.receiverAddress
        } else {
          data.expressCompany = SELF_PICKUP
        }
        if (isOffline) {
          data.offlinePayPrice = Number(this.form.offlinePayPrice)
        } else {
          data.wxCode = wxCode
        }
        const res = await mallH5CreateOrder(data)
        const { orderNo, payConfig } = res.data
        if (this.mode === 'cart') {
          clearCart()
        }
        sessionStorage.removeItem('mall_buy_now')
        if (isOffline) {
          // 线下付款:仅返回orderNo,跳转线下提交成功页,无需清code/唤起支付
          this.$router.replace({ path: '/h5/mall/offlineResult', query: withCtx({ orderNo }) })
          return
        }
        // 微信授权code为一次性,下单已消耗,清除以便下次重新授权
        clearWxCode()
        this.$router.replace({ path: '/h5/mall/payresult', query: withCtx({ orderNo }) })
        if (payConfig && payConfig.paySign) {
          this.invokeWxPay(payConfig)
        }
      } catch (e) {
        // 微信支付下单失败(含code已失效):清code,下次重新授权;线下付款无code可清
        if (!isOffline) clearWxCode()
      } finally {
        this.submitting = false
      }
    },
    invokeWxPay(payConfig) {
      // eslint-disable-next-line no-undef
      if (typeof WeixinJSBridge === 'undefined') {
        this.$toast('请在微信中打开完成支付')
        return
      }
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke('getBrandWCPayRequest', {
        appId: payConfig.appId,
        timeStamp: payConfig.timeStamp,
        nonceStr: payConfig.nonceStr,
        package: payConfig.packages,
        signType: payConfig.signType,
        paySign: payConfig.paySign
      }, (r) => {
        if (r.err_msg === 'get_brand_wcpay_request:ok') {
          // 支付成功
        } else if (r.err_msg === 'get_brand_wcpay_request:cancel') {
          this.$toast('已取消支付')
        } else {
          this.$toast('支付失败')
        }
      })
    }
  }
}
</script>

<style scoped>
/* ===== 全局基调 ===== */
.mall-h5 {
  min-height: 100vh;
  background: #F8F4F0;
  padding-bottom: 80px;
  -webkit-font-smoothing: antialiased;
}

/* ===== 顶部导航 ===== */
.mh5-topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  background: #fff;
  font-size: 17px;
  font-weight: 600;
  color: #3C3C3C;
  padding: 0 14px;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
}
.mh5-topbar i {
  position: absolute;
  left: 14px;
  font-size: 20px;
  color: #666;
}

/* ===== 卡片区块 ===== */
.mh5-section {
  background: #fff;
  margin: 12px 14px;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
}
.mh5-section__head {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #3C3C3C;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F0ECE6;
}
.mh5-section__head i {
  font-size: 18px;
  color: #C0392B;
  margin-right: 8px;
}
.mh5-section__count {
  margin-left: auto;
  font-size: 13px;
  font-weight: 400;
  color: #B0A89E;
}

/* ===== 表单行 ===== */
.mh5-form__row {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.mh5-form__row + .mh5-form__row {
  border-top: 1px solid #F8F4F0;
}
.mh5-form__row label {
  width: 72px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}
.mh5-form__row input,
.mh5-form__row textarea {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
  resize: none;
  font-family: inherit;
  color: #3C3C3C;
}
.mh5-form__row input::placeholder,
.mh5-form__row textarea::placeholder {
  color: #C4BDB3;
}
.mh5-form__row--remark {
  border-top: none !important;
}

/* ===== 商品清单 ===== */
.mh5-goods-list {
  margin: 0 -4px;
}
.mh5-goods {
  display: flex;
  padding: 10px 4px;
}
.mh5-goods + .mh5-goods {
  border-top: 1px solid #F8F4F0;
}
.mh5-goods__img {
  width: 64px;
  height: 64px;
  border-radius: 10px;
  overflow: hidden;
  background: #FAF8F6;
  flex-shrink: 0;
  padding: 4px;
  box-sizing: border-box;
}
.mh5-goods__img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.mh5-noimg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #DFD8CF;
  font-size: 12px;
}
.mh5-goods__body {
  flex: 1;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mh5-goods__name {
  font-size: 14px;
  color: #3C3C3C;
  line-height: 1.4;
  font-weight: 500;
}
.mh5-goods__spec {
  font-size: 12px;
  color: #B0A89E;
  margin-top: 2px;
}
.mh5-goods__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}
.mh5-goods__qty {
  font-size: 13px;
  color: #B0A89E;
}
.mh5-price {
  color: #C0392B;
  font-weight: 600;
  font-size: 15px;
}

/* ===== 配送方式(分段控制器) ===== */
.mh5-seg {
  display: flex;
  background: #F8F4F0;
  border-radius: 10px;
  padding: 3px;
}
.mh5-seg__item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 0;
  font-size: 14px;
  color: #8C8580;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}
.mh5-seg__item.is-active {
  background: #fff;
  color: #C0392B;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
}
.mh5-seg__item .van-icon { font-size: 16px; }

/* 分段控制器下方的收货信息表单:与控制器用分隔线区隔 */
.mh5-seg + .mh5-form {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #F0ECE6;
}

/* 线下自提提示 */
.mh5-pickup-tip {
  display: flex;
  align-items: center;
  margin-top: 12px;
  padding: 14px 12px;
  background: #FFF9F0;
  border: 1px solid #F0E4CC;
  border-radius: 10px;
}
.mh5-pickup-tip__icon { font-size: 22px; color: #C9A96E; margin-right: 10px; flex-shrink: 0; }
.mh5-pickup-tip__text { font-size: 13px; color: #8C7A5A; line-height: 1.5; }

/* ===== 付款方式 ===== */
.mh5-pay { margin: 0 -4px; }
.mh5-pay__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 4px;
  cursor: pointer;
}
.mh5-pay__item + .mh5-pay__item { border-top: 1px solid #F8F4F0; }
.mh5-pay__left { display: flex; align-items: center; }
.mh5-pay__icon { font-size: 22px; margin-right: 10px; }
.mh5-pay__icon--wx { color: #07C160; }
.mh5-pay__icon--offline { color: #C9A96E; }
.mh5-pay__name { font-size: 15px; color: #3C3C3C; }
.mh5-pay__check { font-size: 18px; color: #C4BDB3; }
.mh5-pay__item.is-active .mh5-pay__check { color: #C0392B; }

.mh5-pay__amount {
  display: flex;
  align-items: center;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #F0ECE6;
}
.mh5-pay__amount label {
  width: 72px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}
.mh5-pay__amount-input {
  flex: 1;
  display: flex;
  align-items: center;
  background: #FAF8F6;
  border-radius: 8px;
  padding: 8px 12px;
}
.mh5-pay__amount-symbol {
  color: #C0392B;
  font-weight: 600;
  font-size: 15px;
  margin-right: 4px;
}
.mh5-pay__amount-input input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: #3C3C3C;
  font-family: inherit;
}
.mh5-pay__amount-input input::placeholder { color: #C4BDB3; }
.mh5-pay__tip {
  margin-top: 10px;
  font-size: 12px;
  color: #C9A96E;
  line-height: 1.5;
}
.mh5-pay__tip .van-icon {
  font-size: 13px;
  vertical-align: -1px;
  margin-right: 2px;
}

/* ===== 底部安全区 ===== */
.mh5-safe-bottom { height: 16px; }

/* ===== 底部提交栏 ===== */
.mh5-submit {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 14px;
  box-shadow: 0 -2px 12px rgba(0,0,0,0.06);
  z-index: 20;
  padding-bottom: env(safe-area-inset-bottom);
}
.mh5-submit__total {
  flex: 1;
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.mh5-submit__label {
  font-size: 14px;
  color: #666;
}
.mh5-submit__price {
  font-size: 22px;
  font-weight: 700;
  color: #C0392B;
}
.mh5-submit__origin {
  font-size: 13px;
  color: #B0A89E;
  text-decoration: line-through;
  margin-left: 6px;
  font-weight: 400;
}
.mh5-submit__btn {
  background: linear-gradient(135deg, #C0392B, #A3312A);
  color: #fff;
  padding: 12px 28px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 4px 14px rgba(192,57,43,0.3);
  cursor: pointer;
  transition: opacity 0.2s;
  letter-spacing: 1px;
}
.mh5-submit__btn.disabled {
  background: #D4CFC8;
  box-shadow: none;
  cursor: default;
}
</style>
